import { graphql } from "gatsby";
import React from "react";

import ArrowLink from "../components/ArrowLink";

const LinksParagraph = ({ content }) => (
  <>
    {content.links.map((link) => (
      <ArrowLink href={link.uri}>{link.title}</ArrowLink>
    ))}
  </>
);

export const query = graphql`
  fragment ParagraphLinks on paragraph__links {
    __typename
    links: field_links {
      title
      uri
    }
  }
`;

export default LinksParagraph;
